import React from "react";
import View from "common/View";
import StatsLatencyReport from "./Report";
import help from "help/viewLatencyStats.md";

const StatsLatency = ({returnView = null}) => (
  <View title="Latency" mdHelp={help} returnView={returnView}>
    <StatsLatencyReport returnView={returnView} />
  </View>
);

export default StatsLatency;
